export const environment = {
    appVersion: require('../../package.json').version + '-dev',
    email: '',
    password: '',
};
